export default __webpack_public_path__ + "static/media/dark.dfc442ff.svg";